import Badge from "@/components/design-system/badge";
import SolidCheckmark from "public/next-public/common/icons/checkmark-solid-icon.svg";

function AuthorizedDistributorBadge() {
  return (
    <Badge
      label="Authorized Distributor"
      color="green"
      icon={<SolidCheckmark width={12} height={12} aria-hidden />}
      tooltip={TOOLTIP_TEXT}
      tooltipPlacement="below"
    />
  );
}

export default AuthorizedDistributorBadge;

const TOOLTIP_TEXT =
  "This seller certifies they are authorized by the manufacturer to distribute this product, ensuring product authenticity and eligibility for promotions.";
